export const aboutData = {
    title: "About me",
    description1: "Dhivya here! I'm a web developer and learning enthusiast from Chennai.",
    description2: "An probationer learning cool stuffs and looking forward to accentuate my competency.I spend my leisure hours vibing to music and dancing all the way. I love to learn and explore new arenas.",
}